
class Tracking {
    onTrackEvent = (key: string, value: any) => {

    }
}

export default new Tracking();
